import React from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = {
  '/':              { title: 'Dashboard',     sub: 'Overview & recent activity' },
  '/patients':      { title: 'Patients',      sub: 'Patient records & registrations' },
  '/appointments':  { title: 'Appointments',  sub: 'Schedule & manage visits' },
  '/notifications': { title: 'Notifications', sub: 'WhatsApp delivery log' },
  '/staff':         { title: 'Staff',         sub: 'Team management' },
  '/hospitals':     { title: 'Hospitals',     sub: 'Multi-tenant management' },
  '/audit':         { title: 'Audit Logs',    sub: 'Security & compliance trail' },
};

export default function TopBar({ user, onMenuOpen }) {
  const location = useLocation();
  const meta     = TITLES[location.pathname] || { title: 'Praveda', sub: '' };

  return (
    <div style={{
      height: 62,
      background: 'var(--topbar-bg)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid var(--topbar-border)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 24px', position: 'sticky', top: 0, zIndex: 50,
      transition: 'background 0.25s, border-color 0.25s',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <button onClick={onMenuOpen} className="hamburger" style={{
          display: 'none', background: 'none', border: 'none',
          cursor: 'pointer', padding: 4, fontSize: 20, color: '#94a3b8', lineHeight: 1,
        }}>☰</button>
        <div>
          <div className="topbar-title" style={{ fontSize: 16, fontWeight: 800, color: 'var(--text-primary)', letterSpacing: 0.2 }}>{meta.title}</div>
          <div className="topbar-sub" style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>{meta.sub}</div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div className="topbar-search" style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'var(--bg-input)',
          border: '1px solid var(--border)',
          borderRadius: 9, padding: '7px 14px',
        }}>
          <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>🔍</span>
          <input placeholder="Search..." style={{
            border: 'none', background: 'transparent', outline: 'none',
            fontSize: 13, color: 'var(--text-sub)', width: 160,
          }} />
        </div>

        <div style={{ width: 1, height: 28, background: 'var(--border)' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <div style={{
            width: 34, height: 34, borderRadius: '50%',
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: 13, fontWeight: 700, flexShrink: 0,
            boxShadow: '0 2px 8px rgba(99,102,241,0.4)',
          }} title={user?.name || 'User'}>
            {user?.name?.[0]?.toUpperCase() || 'U'}
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-primary)' }}>{user?.name || 'User'}</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)', textTransform: 'capitalize' }}>{user?.role?.replace('-', ' ')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
